// extracted by mini-css-extract-plugin
export default {"search-text":"HighlightedText_search-text__mNKBu","searchText":"HighlightedText_search-text__mNKBu"};